<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('s-o.title', 'Налаштування опцій') }}</h1>
          <!--          <button class="default-btn btn-with-icon btn-accent" @click="addNew">-->
          <!--            <span class="text">{{$static('s-o.btn-add', 'Додати')}}</span>-->
          <!--            <span class="icon icon-add"></span>-->
          <!--          </button>-->
        </div>

        <div class="default-cards-list minimal-list">
          <div class="default-cards-top">
            <div class="name name-category">{{ $static('s-o.name', 'Назва опції') }}</div>
            <div class="name name-actions">{{ $static('s-o.actions', 'Виконати дії') }}</div>
          </div>
          <div class="default-card-layout" style="cursor: pointer" @click="addNew">
            <div class="default-card-content">
              <div class="default-card-main">
                <div class="default-card-title">{{ $static('s-o.btn-add', 'Додати') }}
                  <span class="icon icon-add"></span>
                </div>
              </div>

            </div>
          </div>
          <div class="default-card-layout" v-for="(option, index) in settings" :key="index" style="cursor: pointer">
            <div class="default-card-content" v-if="option.deleted === undefined"
              @click.prevent.stop="goToOption(option)">
              <div class="default-card-main">
                <div class="default-card-title">{{ option.option }}</div>
              </div>
              <div class="actions-box">
                <Popper arrow :content="$static('iconsbtn.edit', 'Редагувати')" hover placement="top"
                  style="white-space: nowrap">
                  <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger"
                    @click.prevent.stop="openEditor(option)">
                    <span class="icon icon-edit"></span>
                  </button>
                </Popper>

                <!--                <button class="btn-icon btn-rounded btn-icon-transparent editor_trigger" title="дублировать" @click="">-->
                <!--                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--                    <path-->
                <!--                        d="M13.75 2.97917C16.661 2.97917 19.0209 5.339 19.0209 8.25V14.7646C19.0209 15.1443 18.7131 15.4521 18.3334 15.4521C17.9537 15.4521 17.6459 15.1443 17.6459 14.7646V8.25C17.6459 6.09839 15.9017 4.35417 13.75 4.35417H7.32159C6.94189 4.35417 6.63409 4.04636 6.63409 3.66667C6.63409 3.28697 6.94189 2.97917 7.32159 2.97917H13.75Z"-->
                <!--                        fill="#212121"/>-->
                <!--                    <path fill-rule="evenodd" clip-rule="evenodd"-->
                <!--                          d="M5.13103 6.22715C8.10191 5.89512 11.1481 5.89512 14.119 6.22715C14.9654 6.32174 15.6455 6.98779 15.7452 7.84069C16.0976 10.8533 16.0976 13.8967 15.7452 16.9093C15.6455 17.7622 14.9654 18.4283 14.119 18.5228C11.1481 18.8549 8.10191 18.8549 5.13103 18.5228C4.2847 18.4283 3.60459 17.7622 3.50484 16.9093C3.15248 13.8967 3.15248 10.8533 3.50484 7.84069C3.60459 6.98779 4.2847 6.32174 5.13103 6.22715ZM13.9663 7.59365C11.0969 7.27295 8.15313 7.27295 5.28376 7.59365C5.06619 7.61796 4.89513 7.79003 4.87053 8.00042C4.53059 10.9069 4.53059 13.8431 4.87053 16.7496C4.89513 16.96 5.06619 17.132 5.28376 17.1564C8.15313 17.477 11.0969 17.477 13.9663 17.1564C14.1839 17.132 14.3549 16.96 14.3795 16.7496C14.7195 13.8431 14.7195 10.9069 14.3795 8.00042C14.3549 7.79003 14.1839 7.61796 13.9663 7.59365Z"-->
                <!--                          fill="#212121"/>-->
                <!--                  </svg>-->
                <!--                </button>-->
                <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
                  style="white-space: nowrap">
                  <a href="#" class="btn-icon btn-rounded btn-icon-transparent btn-remove"
                    @click.prevent.stop="removeItem(option)">
                    <span class="icon icon-trash"></span>
                  </a>
                </Popper>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!--! Редактор опций -->
    <Teleport to="body">
      <!-- EDITOR WRAPPER-->
      <div class="overlay-editor item-editor">
        <div class="overlay-editor-wrapper" v-if="selected">
          <div class="panel-top">
            <div class="lang-selector-holder d-flex align-items-center">
              <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:')
                }}</label>
              <LangSelector v-model="lang" />
            </div>
            <a href="javascript:void(0);" class="back_trigger" @click="cancel">
              <span class="icon icon-cross"></span>
            </a>
          </div>
          <div class="panel-middle">
            <h3 class="panel-top-name">{{ $static('s-o.editor', 'Редагування тегу') }}</h3>
            <div class="row">
              <div class="col">
                <div class="form-group" id="tagname">
                  <div class="custom-label">{{ $static('s-o.tagname', 'Назва тегу') }}</div>
                  <template v-if="basicLang">
                    <input type="text" class="form-control custom-input" v-model="selected.option">
                  </template>
                  <template v-else>
                    <input type="text" class="form-control custom-input" v-model="translate.option" :placeholder="name"
                      @update:modelValue="e => setTranslate('option', e)">
                  </template>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="option-box">
                  <div class="option-line" id="siin">
                    <div class="option-name">{{ $static('s-o.siin', 'Можна вибрати лише один') }}</div>
                    <div class="toggle-holder">
                      <div class="toggler r">
                        <input type="checkbox" class="toggle-check" v-model="singleMode">
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="option-box">
                  <div class="option-line" id="sireq">
                    <div class="option-name">{{ $static('s-o.sireq', 'Обов\'язковий') }}</div>
                    <div class="toggle-holder">
                      <div class="toggler r">
                        <input type="checkbox" class="toggle-check" v-model="requiredMode">
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-bottom">
            <button class="transparent-btn default-btn back_trigger" @click="cancel">
              <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
            </button>
            <button class=" default-btn btn-accent" @click="save">
              <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
            </button>
            <!--            <button class=" default-btn btn-red">-->
            <!--              <span class="text">Видалити</span>-->
            <!--            </button>-->
          </div>
        </div>
      </div>
      <!--END EDITOR WRAPPER-->
    </Teleport>

  </div>
</template>

<script>
import api from '@/api'
import { Chrome } from '@lk77/vue3-color'
import LangSelector from '../components/LangSelector';
import OptionEditor from '../components/OptionEditor';
import OptionEditorFull from '../components/OptionEditorFull';
// import { Chrome } from 'vue-color'

export default {
  name: 'SettingsOptions',
  components: { LangSelector },
  data() {
    return {
      settings: [],
      lang: '',
      selected: undefined,
      singleMode: false,
      requiredMode: false,
      load: false
    }
  },
  computed: {
    langs() {
      return this.$store.getters.settings
        && this.$store.getters.settings.public
        && this.$store.getters.settings.public.lang
        && Array.isArray(this.$store.getters.settings.public.lang) ?
        this.$store.getters.settings.public.lang : []
    },
    basicLang() {
      return this.lang === ''
    },
    translate: {
      get() {
        return this.lang && this.selected && this.selected.translate && this.selected.translate[this.lang] ? this.selected.translate[this.lang] : {}
      },
      set(value) {
      }
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    setTranslate(key, value) {
      if (!this.selected.translate || Array.isArray(this.selected.translate)) {
        this.selected.translate = {}
      }
      if (!this.selected.translate[this.lang]) {
        this.selected.translate[this.lang] = {}
      }
      this.selected.translate[this.lang][key] = value
    },

    async getItems() {
      let resp = await api.get('/api/options/settings')
      this.settings = resp.data
    },

    cancel() {
      this.selected = undefined;
      this.singleMode = false;
      this.requiredMode = false;

      // window.$('.filter_sidebar').addClass('active');
      window.$('.overlay-editor.item-editor').toggleClass('active');
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');


      window.$('.back-blur').off('click');

      window.$('.back-blur').on('click', function () {
        window.$('body > .active').removeClass('active');
        window.$('body').removeClass('is-hidden');
      });
    },

    goToOption(option) {
      this.$router.push({ name: 'Options', params: { option_id: option.option_id } })
    },

    openEditor(item, event) {
      window.$('.back-blur').off('click'); // удаляем слушатель события клика на бэк-блюр поставленный в AdminBox. Он визуально скрывает модальное окно слишком рано - до момента сохранения данных и или их обновления.
      window.$('.back-blur').on('click', () => this.cancel());

      this.selected = item;

      if (!this.selected.info) {
        this.selected.info = {
          single: false,
          req: false
        }

        this.singleMode = false;
        this.requiredMode = false;
      }

      this.singleMode = this.selected.info.single;
      this.requiredMode = this.selected.info.req;

      // window.$(event.target).toggleClass('open');
      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');
      window.$('.back-blur').toggleClass('active');
      window.$('.overlay-editor.item-editor').toggleClass('active');
    },

    async save() {
      if (this.load) {
        return
      }

      this.load = true;
      try {
        this.selected.info = {
          single: this.singleMode,
          req: this.requiredMode
        }

        if (this.selected?.id !== undefined) {

          const resp = await api.put('/api/options/settings', this.selected)
          const data = resp.data;

          let idx = this.settings.findIndex(i => i.id === data.id);
          if (idx > -1) {
            this.settings[idx] = Object.assign(this.settings[idx], data)
          }
        } else {
          await api.post('/api/options/settings', { list: [this.selected] })
        }

        await this.getItems();

        this.$notify({
          title: this.$static('options.title', 'Опції'),
          text: this.$static('notify.save', 'Збережено.'),
          duration: 3000
        });

        this.cancel();
      } catch (error) {

        console.error('Error saving settings:', error);

        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('notify.error', 'Помилка при збереженні данних.'),
          type: 'error',
          duration: 3000
        });

      } finally {
        this.load = false;
      }
    },

    removeItem(item, event) {
      window.$('#confirm-modal').modal('show');
      window.onModalConfirm = () => {
        api.delete(`/api/options/settings/${item.id}`);
        let idx = this.settings.findIndex(i => i.id === item.id);
        if (idx > -1) {
          this.settings[idx].deleted = true
        }
      }
    },

    addNew() {
      this.selected = { translate: {}, info: { req: false, single: false } };
      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');

      window.$('.back-blur').toggleClass('active');
      window.$('.overlay-editor.item-editor').toggleClass('active');
    }
  }
}
</script>

<style scoped></style>